// extracted by mini-css-extract-plugin
export var cardTitle = "_io-1";
export var commentBubble = "_io-e";
export var commentForm = "_io-a";
export var commentInput = "_io-b";
export var commentLabel = "_io-d";
export var commentPrompt = "_io-9";
export var csatCard = "_io-0";
export var feedbackSection = "_io-7";
export var starDisabled = "_io-6";
export var starEmpty = "_io-5";
export var starFilled = "_io-4";
export var starWrapper = "_io-3";
export var starsContainer = "_io-2";
export var submittedComment = "_io-c";
export var thankYouText = "_io-8";